import { render, staticRenderFns } from "./change_status.vue?vue&type=template&id=c4a2c5c8&scoped=true&"
import script from "./change_status.vue?vue&type=script&lang=js&"
export * from "./change_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a2c5c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a2c5c8')) {
      api.createRecord('c4a2c5c8', component.options)
    } else {
      api.reload('c4a2c5c8', component.options)
    }
    module.hot.accept("./change_status.vue?vue&type=template&id=c4a2c5c8&scoped=true&", function () {
      api.rerender('c4a2c5c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/reports/actions/modals/change_status.vue"
export default component.exports